import { db } from '../lib/firebase';
import { 
  collection, 
  doc, 
  setDoc, 
  deleteDoc, 
  getDoc,
  serverTimestamp,
  query,
  where,
  getDocs
} from 'firebase/firestore';

// Database structure: vindie/{collection}

export type LikeType = 'like' | 'dislike';

export interface Like {
  id?: string;
  contentId: string;
  userId: string;
  type: LikeType;
  createdAt: any;
}

export async function toggleLike(contentId: string, userId: string, type: LikeType): Promise<{ action: 'added' | 'removed' | 'changed', newType?: LikeType }> {
  const likeId = `${userId}_${contentId}`;
  const ref = doc(db, 'likes', likeId);
  const snap = await getDoc(ref);
  
  if (!snap.exists()) {
    await setDoc(ref, {
      contentId,
      userId,
      type,
      createdAt: serverTimestamp()
    });
    return { action: 'added', newType: type };
  }
  
  const existingLike = snap.data() as Like;
  
  if (existingLike.type === type) {
    await deleteDoc(ref);
    return { action: 'removed' };
  } else {
    await setDoc(ref, {
      ...existingLike,
      type,
      createdAt: serverTimestamp()
    });
    return { action: 'changed', newType: type };
  }
}

export async function getUserLike(contentId: string, userId: string): Promise<LikeType | null> {
  const likeId = `${userId}_${contentId}`;
  const ref = doc(db, 'likes', likeId);
  const snap = await getDoc(ref);
  
  if (!snap.exists()) return null;
  
  const like = snap.data() as Like;
  return like.type;
}

export async function getContentLikes(contentId: string): Promise<{ likes: number; dislikes: number }> {
  const q = query(collection(db, 'likes'), where('contentId', '==', contentId));
  const snap = await getDocs(q);
  
  let likes = 0;
  let dislikes = 0;
  
  snap.docs.forEach(doc => {
    const like = doc.data() as Like;
    if (like.type === 'like') likes++;
    else if (like.type === 'dislike') dislikes++;
  });
  
  return { likes, dislikes };
}
